var map = {
	"./Anyswap.png": 55947,
	"./Anyswap.svg": 55152,
	"./Artwork.svg": 56287,
	"./Artwork_gmx.svg": 10641,
	"./Banxa.png": 15194,
	"./DROP_DOWN.svg": 18692,
	"./EQUAL.png": 82775,
	"./Hop.png": 79577,
	"./Hop.svg": 68415,
	"./Hop_dark.png": 20815,
	"./Hop_dark.svg": 45106,
	"./MMY-ETH.svg": 95523,
	"./MMY-FTM.svg": 27159,
	"./Squid.svg": 20138,
	"./Synapse.png": 3935,
	"./Synapse.svg": 73391,
	"./analytics/bg-header.png": 11856,
	"./analytics/fee.png": 29821,
	"./analytics/ic-pnl.svg": 52509,
	"./analytics/ic-search-wallet.svg": 48741,
	"./analytics/img-header.svg": 41124,
	"./analytics/linked.png": 21167,
	"./analytics/mlpPool.svg": 78189,
	"./analytics/openInterest.svg": 57127,
	"./analytics/pool.png": 24163,
	"./analytics/right-img.svg": 28744,
	"./analytics/totalFee.svg": 3757,
	"./analytics/totalUser.svg": 90054,
	"./analytics/totalVolumn.png": 3854,
	"./analytics/totalVolumn.svg": 67554,
	"./analytics/user.png": 52600,
	"./backyellowicon.svg": 93702,
	"./binance.png": 66030,
	"./bitkeep.svg": 42267,
	"./bridge.svg": 24232,
	"./bridge/Checkbox.svg": 48189,
	"./bridge/Checkbox_Checked.svg": 48689,
	"./bridge/bolt.svg": 16691,
	"./bridge/close.svg": 82325,
	"./bridge/empty.png": 80961,
	"./bridge/ic-plus.svg": 38614,
	"./bridge/mmy.svg": 63870,
	"./bridge/new_checkbox.svg": 83605,
	"./bridge/new_checkbox_check.svg": 46788,
	"./bridge/nft-item.svg": 11703,
	"./bridge/nft.svg": 81927,
	"./bscscan.png": 81128,
	"./btn_big_arbitrum.png": 70756,
	"./btn_big_avalanche.png": 11784,
	"./btn_big_bsc.png": 74872,
	"./btn_big_purchasegmx.png": 43760,
	"./btn_big_purchasegmx.svg": 12346,
	"./buy_gmx.svg": 59709,
	"./buy_gmx_bond.svg": 17868,
	"./buy_transfer_eth.svg": 66961,
	"./check_icon.svg": 9891,
	"./coinbaseWallet.png": 32346,
	"./coingecko.png": 64993,
	"./coppy.svg": 16233,
	"./copy.svg": 87823,
	"./cross.svg": 77150,
	"./dashboard/ftm.svg": 8110,
	"./dashboard/longPosition.svg": 79248,
	"./dashboard/op.svg": 34727,
	"./dashboard/openInterest.svg": 97771,
	"./dashboard/pattern.svg": 28279,
	"./dashboard/shortPosition.svg": 51512,
	"./dashboard/since.svg": 96096,
	"./dashboard/tfee.svg": 5228,
	"./dashboard/tuser.svg": 86107,
	"./dashboard/tvl.svg": 47726,
	"./dashboard/tvolumn.svg": 81920,
	"./downArrow.svg": 1137,
	"./earn/bg.svg": 56360,
	"./earn/mlp_coin.svg": 53186,
	"./earn/mmy_coin.svg": 829,
	"./earn/overview.svg": 56265,
	"./earn/rewards.svg": 73475,
	"./earn/tab_mlp.svg": 2454,
	"./earn/tab_mmy.svg": 75546,
	"./earn/tab_transfer.svg": 60818,
	"./earn/tab_vault.svg": 67122,
	"./earn/tab_vest.svg": 59451,
	"./flag_en.svg": 49124,
	"./flag_es.svg": 95372,
	"./flag_fr.svg": 60839,
	"./flag_ja.svg": 44850,
	"./flag_ko.svg": 85160,
	"./flag_ru.svg": 76176,
	"./flag_zh.svg": 85896,
	"./frame_referrals.svg": 21241,
	"./frame_sticker.svg": 2255,
	"./frame_trading.svg": 32424,
	"./gateio.svg": 33610,
	"./glp_icon.svg": 3689,
	"./gmx-logo-final-white-small.png": 60860,
	"./gmx-logo-final-white.png": 17638,
	"./gmx-logo-final.png": 66289,
	"./gmx-logo-glow.png": 26844,
	"./gmx-logo-with-name.svg": 37058,
	"./gmx_logo.svg": 44368,
	"./graphite-01.png": 26020,
	"./header_ref.svg": 11645,
	"./home/1inch.svg": 27971,
	"./home/background-v3.svg": 40815,
	"./home/banner-avt.png": 36671,
	"./home/banner-avt2.png": 5027,
	"./home/banner-bg-small-ip.png": 12156,
	"./home/banner-bg-small-ip2.png": 3022,
	"./home/banner-bg-small-mobile.png": 82000,
	"./home/banner-bg-small-mobile2.png": 10564,
	"./home/banner-bg-small.png": 34853,
	"./home/banner-bg-small2.png": 72375,
	"./home/banner-bg.png": 88447,
	"./home/banner-bg2.png": 53067,
	"./home/banner-vector.png": 14390,
	"./home/banner-vector2.png": 83503,
	"./home/bg.png": 57149,
	"./home/chain_pattern.svg": 38114,
	"./home/club1.svg": 51041,
	"./home/club2.svg": 16222,
	"./home/coinGecko.svg": 61852,
	"./home/coinMarketCap.svg": 11167,
	"./home/dappRadar.svg": 28103,
	"./home/deBank.svg": 36106,
	"./home/defiLlama.svg": 57037,
	"./home/equalizer.svg": 95211,
	"./home/fantom.svg": 45139,
	"./home/fireBird.svg": 71278,
	"./home/ftmBackdrop.svg": 74326,
	"./home/ic-mint.svg": 63168,
	"./home/ic-opensea.svg": 84979,
	"./home/ic_bnb.svg": 16144,
	"./home/ic_btc.svg": 8108,
	"./home/ic_custody.svg": 61015,
	"./home/ic_dai.svg": 68724,
	"./home/ic_eth.svg": 98381,
	"./home/ic_friendly.svg": 98498,
	"./home/ic_ftm.svg": 31080,
	"./home/ic_leveraged.svg": 42714,
	"./home/ic_lowFee.svg": 63132,
	"./home/ic_play.svg": 21553,
	"./home/ic_transprency.svg": 95484,
	"./home/ic_usdc.svg": 98163,
	"./home/ic_usdt.svg": 53027,
	"./home/ic_yeild.svg": 28723,
	"./home/kyberSwap.svg": 44530,
	"./home/landingpage-v3-bg.svg": 26646,
	"./home/lbBank.svg": 78105,
	"./home/mexc.svg": 15526,
	"./home/mum1.png": 22985,
	"./home/mum2.png": 57883,
	"./home/mum3.png": 53350,
	"./home/mum4.png": 59603,
	"./home/mum5.png": 23873,
	"./home/nft1.png": 47630,
	"./home/nft2.png": 27981,
	"./home/odos.svg": 33920,
	"./home/opBackdrop.svg": 77055,
	"./home/openOcean.svg": 92631,
	"./home/optimize-right-img.svg": 30993,
	"./home/optimize.svg": 17710,
	"./home/qSwap.svg": 6224,
	"./home/reduce.svg": 80823,
	"./home/saveCost.svg": 29313,
	"./home/spooky.svg": 90188,
	"./home/superiority-bg-mobile.svg": 32681,
	"./home/superiority-bg.svg": 67006,
	"./home/swap.svg": 9031,
	"./home/tokenTerminal.svg": 39285,
	"./home/totalFees.svg": 99672,
	"./home/totalTradingVolume.svg": 24727,
	"./home/totalUsers.svg": 37078,
	"./home/totalValueLocked.svg": 98655,
	"./home/velodrome.svg": 63601,
	"./home/voyager.svg": 86484,
	"./home/wonderland.svg": 84074,
	"./ic-acc-fee.svg": 9814,
	"./ic-communityproject.svg": 78046,
	"./ic-pnl.svg": 38961,
	"./ic-view.svg": 67422,
	"./ic-volume.svg": 86830,
	"./icARB.svg": 56106,
	"./icFantom.svg": 92444,
	"./icOP.svg": 71105,
	"./ic_1inch.svg": 67772,
	"./ic_across.svg": 13289,
	"./ic_arb_24.svg": 56865,
	"./ic_arb_40.svg": 8270,
	"./ic_arbitrum_16.svg": 41898,
	"./ic_arbitrum_24.svg": 79762,
	"./ic_arbitrum_96.svg": 99060,
	"./ic_arbitrum_hover_16.svg": 48133,
	"./ic_arrow.svg": 15283,
	"./ic_arrowleft16.svg": 71774,
	"./ic_arrowright16.svg": 95143,
	"./ic_avalanche_16.svg": 5412,
	"./ic_avalanche_24.svg": 84820,
	"./ic_avalanche_96.svg": 90742,
	"./ic_avax_24.svg": 90750,
	"./ic_avax_30.svg": 10506,
	"./ic_avax_40.svg": 22807,
	"./ic_axlbtc_24.svg": 15656,
	"./ic_axlbtc_40.svg": 41940,
	"./ic_axleth_24.svg": 1511,
	"./ic_axleth_40.svg": 7558,
	"./ic_axlusdc_24.svg": 35806,
	"./ic_axlusdc_40.svg": 80872,
	"./ic_axlusdt_24.svg": 99582,
	"./ic_axlusdt_40.svg": 3829,
	"./ic_banxa.svg": 75136,
	"./ic_base_16.svg": 35051,
	"./ic_base_24.svg": 51390,
	"./ic_base_40.svg": 84665,
	"./ic_binance.svg": 57424,
	"./ic_binance_logo.svg": 85685,
	"./ic_bnb_16.svg": 2476,
	"./ic_bnb_24.svg": 74480,
	"./ic_bnb_40.svg": 44811,
	"./ic_bsc.svg": 47680,
	"./ic_bsc_96.svg": 65163,
	"./ic_btc.b_24.svg": 68279,
	"./ic_btc.b_40.svg": 91709,
	"./ic_btc_24.svg": 49351,
	"./ic_btc_40.svg": 80543,
	"./ic_btc_l0_24.svg": 84285,
	"./ic_btc_l0_40.svg": 80157,
	"./ic_bungee.png": 58595,
	"./ic_busd_24.svg": 99823,
	"./ic_buy_glp.svg": 9333,
	"./ic_buy_mlp.svg": 4419,
	"./ic_bybit.svg": 37557,
	"./ic_cash.png": 33795,
	"./ic_cash.svg": 42531,
	"./ic_cbeth_24.svg": 12506,
	"./ic_cbeth_40.svg": 70538,
	"./ic_checked.svg": 21019,
	"./ic_coinbase.svg": 81497,
	"./ic_coingecko_16.svg": 85613,
	"./ic_coingecko_hover_16.svg": 29277,
	"./ic_convert_down.svg": 34935,
	"./ic_copy_16.svg": 15603,
	"./ic_cost.svg": 97906,
	"./ic_dai_24.svg": 86592,
	"./ic_dai_40.svg": 9641,
	"./ic_dai_l0_24.svg": 41699,
	"./ic_dai_l0_40.svg": 85518,
	"./ic_discord.svg": 21797,
	"./ic_dodo.svg": 13394,
	"./ic_down_white.svg": 12718,
	"./ic_email.svg": 50747,
	"./ic_equalizer.png": 33600,
	"./ic_eth_24.svg": 47639,
	"./ic_eth_40.svg": 78432,
	"./ic_eth_l0_24.svg": 83366,
	"./ic_eth_l0_40.svg": 90565,
	"./ic_firebird.png": 83041,
	"./ic_frax_24.svg": 5790,
	"./ic_frax_40.svg": 90630,
	"./ic_ftm_16.svg": 54674,
	"./ic_ftm_24.svg": 55245,
	"./ic_ftm_40.svg": 34286,
	"./ic_fxs_16.svg": 27189,
	"./ic_fxs_24.svg": 35378,
	"./ic_fxs_32.svg": 80162,
	"./ic_fxs_40.svg": 10347,
	"./ic_github.svg": 27467,
	"./ic_glp_24.svg": 98052,
	"./ic_glp_40.svg": 43798,
	"./ic_glp_custom.svg": 82842,
	"./ic_gmx.svg": 81790,
	"./ic_gmx_24.svg": 86268,
	"./ic_gmx_30.svg": 49772,
	"./ic_gmx_40.svg": 572,
	"./ic_gmx_64.svg": 36172,
	"./ic_gmx_arbitrum.svg": 75356,
	"./ic_gmx_avax.svg": 92967,
	"./ic_gmx_big.svg": 42876,
	"./ic_gmx_custom.svg": 55133,
	"./ic_gmx_footer.svg": 21986,
	"./ic_hop.svg": 86934,
	"./ic_huobi.svg": 94052,
	"./ic_info.svg": 38628,
	"./ic_kucoin.svg": 9039,
	"./ic_kyber.svg": 65527,
	"./ic_language24.svg": 71085,
	"./ic_link_16.svg": 44856,
	"./ic_link_24.svg": 88956,
	"./ic_link_32.svg": 65680,
	"./ic_link_40.svg": 79529,
	"./ic_liquidity.svg": 76738,
	"./ic_matcha.png": 71243,
	"./ic_medium.svg": 57488,
	"./ic_menu_dots.svg": 64337,
	"./ic_metamask_16.svg": 31356,
	"./ic_metamask_hover_16.svg": 68177,
	"./ic_mexc.png": 25288,
	"./ic_mim_24.svg": 95643,
	"./ic_mim_40.svg": 17928,
	"./ic_mlp_24.svg": 97984,
	"./ic_mlp_40.svg": 57777,
	"./ic_mlp_custom.svg": 26342,
	"./ic_mmy_24.svg": 61964,
	"./ic_mmy_30.svg": 24849,
	"./ic_mmy_40.svg": 36190,
	"./ic_mmy_64.svg": 18967,
	"./ic_mmy_custom.svg": 36387,
	"./ic_mmy_plh.png": 89336,
	"./ic_multiswap.svg": 49215,
	"./ic_new_link_16.svg": 60613,
	"./ic_noitemfound.svg": 42106,
	"./ic_o3.png": 36666,
	"./ic_odos.png": 82284,
	"./ic_olympus.svg": 39219,
	"./ic_olympus_arbitrum.svg": 17682,
	"./ic_op_16.svg": 42742,
	"./ic_op_24.svg": 55605,
	"./ic_op_40.svg": 70711,
	"./ic_op_96.svg": 45908,
	"./ic_openocean.svg": 87132,
	"./ic_paraswap.svg": 35071,
	"./ic_rdnt_24.svg": 88019,
	"./ic_rdnt_40.svg": 18527,
	"./ic_scan.svg": 60308,
	"./ic_scan_white.svg": 76493,
	"./ic_selector_dropdowns.svg": 31370,
	"./ic_settings_16.svg": 88317,
	"./ic_settings_24.svg": 94240,
	"./ic_sign in_16.svg": 37516,
	"./ic_sign_out_16.svg": 98741,
	"./ic_simpleswaps.svg": 50240,
	"./ic_skeleton.svg": 38291,
	"./ic_slingshot.svg": 93149,
	"./ic_snx_16.svg": 78779,
	"./ic_snx_24.svg": 90201,
	"./ic_snx_32.svg": 14024,
	"./ic_snx_40.svg": 82930,
	"./ic_spooky.svg": 55667,
	"./ic_stats.svg": 98865,
	"./ic_stats_big.svg": 39236,
	"./ic_synapse.svg": 56993,
	"./ic_tbtc_24.svg": 38665,
	"./ic_tbtc_40.svg": 36780,
	"./ic_telegram.svg": 50933,
	"./ic_tether_24.svg": 8466,
	"./ic_tokens.svg": 12870,
	"./ic_totaluser.svg": 26141,
	"./ic_traderjoe.png": 81157,
	"./ic_trading.svg": 35095,
	"./ic_transfer_avax.svg": 54478,
	"./ic_twitter.svg": 16396,
	"./ic_twitter_new.svg": 54238,
	"./ic_uni_24.svg": 61691,
	"./ic_uni_40.svg": 79812,
	"./ic_uni_arbitrum.svg": 78610,
	"./ic_usdbc_24.svg": 12051,
	"./ic_usdbc_40.svg": 9208,
	"./ic_usdc.e_24.svg": 40890,
	"./ic_usdc.e_40.svg": 14206,
	"./ic_usdc_24.svg": 8038,
	"./ic_usdc_40.svg": 1924,
	"./ic_usdc_l0_24.svg": 25498,
	"./ic_usdc_l0_40.svg": 38207,
	"./ic_usdt_24.svg": 17039,
	"./ic_usdt_40.svg": 59757,
	"./ic_usdt_l0_24.svg": 30266,
	"./ic_usdt_l0_40.svg": 17426,
	"./ic_velodrome.svg": 211,
	"./ic_wallet_24.svg": 75395,
	"./ic_wavax_24.svg": 62690,
	"./ic_wavax_40.svg": 29994,
	"./ic_wbtc_24.svg": 93205,
	"./ic_wbtc_40.svg": 50195,
	"./ic_weth_24.svg": 9151,
	"./ic_weth_40.svg": 8521,
	"./ic_wftm_16.svg": 26514,
	"./ic_wftm_24.svg": 78139,
	"./ic_wftm_40.svg": 58679,
	"./ic_yield_yak.png": 81411,
	"./icon_vest.svg": 93887,
	"./icons/Checkbox--inactive.svg": 98595,
	"./icons/Checkbox.svg": 83620,
	"./icons/MMY.svg": 57171,
	"./icons/alert.svg": 25668,
	"./icons/chart-pad.svg": 64144,
	"./icons/checkbox-ic.svg": 97455,
	"./icons/checkbox-ic1.svg": 78349,
	"./icons/copy-ic.svg": 76892,
	"./icons/discord.svg": 30297,
	"./icons/download-ic.svg": 15711,
	"./icons/dropdown-ic-header.svg": 77257,
	"./icons/dropdown-ic.svg": 1609,
	"./icons/flash.svg": 12817,
	"./icons/github.svg": 39787,
	"./icons/ic-info.svg": 8984,
	"./icons/ic-prev.svg": 2770,
	"./icons/ic_binance.svg": 35629,
	"./icons/ic_bitfinex.svg": 22520,
	"./icons/ic_bybit.svg": 24153,
	"./icons/ic_coinbase.svg": 5565,
	"./icons/ic_crypto.svg": 24479,
	"./icons/ic_kucoin.svg": 69707,
	"./icons/ic_median.svg": 3452,
	"./icons/ic_okx.svg": 2428,
	"./icons/icon-up.svg": 43450,
	"./icons/link-green.svg": 61457,
	"./icons/link-white.svg": 18522,
	"./icons/link.svg": 17595,
	"./icons/medium.svg": 82422,
	"./icons/mm-usd.svg": 45083,
	"./icons/redirect-green.svg": 57581,
	"./icons/search.svg": 43344,
	"./icons/short_right.svg": 92049,
	"./icons/telegram.svg": 82718,
	"./icons/treasury.svg": 8194,
	"./icons/tweet-ic.svg": 67345,
	"./icons/twitter.svg": 46138,
	"./layer0.svg": 23998,
	"./lg_arbitrum.svg": 96276,
	"./lifi.png": 11944,
	"./lock/bolt.svg": 38771,
	"./lock/img_right.svg": 71530,
	"./lockMMY/arrow_down.svg": 38622,
	"./lockMMY/bg.png": 52527,
	"./lockMMY/bolt.svg": 35364,
	"./lockMMY/boost.svg": 46705,
	"./lockMMY/info.svg": 89267,
	"./lockMMY/mmy_circle_logo.svg": 99562,
	"./lockMMY/nft.png": 59396,
	"./lockMMY/penalty.svg": 8705,
	"./lockMMY/question_mark.svg": 26834,
	"./lockMMY/small-bolt.svg": 97501,
	"./lockMMY/timer.svg": 77402,
	"./lockMMY/up-arrow.svg": 11819,
	"./logo_GMX.svg": 20334,
	"./logo_GMX_small.svg": 19156,
	"./logo_MMY.svg": 34709,
	"./logo_MMY_small.svg": 56476,
	"./long.svg": 54905,
	"./metamask-text.svg": 78232,
	"./metamask.png": 46521,
	"./page-not-found.svg": 39014,
	"./position-share-bg.png": 59430,
	"./rango.png": 97607,
	"./ref_header_cash.svg": 35159,
	"./reload.svg": 38037,
	"./routerTab/mlp.svg": 31424,
	"./routerTab/mmy_esmmy.svg": 3334,
	"./routerTab/overview.svg": 36379,
	"./routerTab/transfer_account.svg": 89315,
	"./routerTab/vault.svg": 40668,
	"./routerTab/vest.svg": 58945,
	"./share.svg": 42574,
	"./short.svg": 28800,
	"./socket-teck.jpeg": 3247,
	"./swap.svg": 1630,
	"./tokens.svg": 79900,
	"./tokens/eth.svg": 53069,
	"./tokens/ftm.svg": 88994,
	"./tooltip.svg": 18070,
	"./trading.jpg": 30393,
	"./triangle.svg": 75067,
	"./twitter.svg": 8906,
	"./upArrow.svg": 61924,
	"./upArrowWhite.svg": 68497,
	"./vote/icon.svg": 90939,
	"./vote/item-icon.svg": 96625,
	"./wallet-connect-text.svg": 51812,
	"./walletconnect-circle-blue.svg": 68891,
	"./wave-01.png": 49338,
	"./wave-02.png": 55046,
	"./xy.svg": 42666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;